import {noop} from '~/utils/fns';

export interface AppContextShape {
    addLanguage: (name: string, messages: {[key: string]: string}) => void;
    fetchingLocale: boolean;
    fetchLocale: (name: string) => Promise<{[key: string]: string}>;
}

export const DEFAULT_APP_CONTEXT: AppContextShape = {
    addLanguage: noop,
    fetchingLocale: false,
    fetchLocale: async () => Promise.resolve(null),
};
